import * as React from 'react';
import ChatStreamContainer from './ChatStreamContainer';
import { Stream, StreamContext, CTX_CHAT_STREAM, StreamPlaceholder } from 'chat/components/Stream';

type Props = {
  uuid: string;
  onScrollToBottom?: () => void;
};

export class ChatStreamPlaceholder extends React.Component<any, any> {
  render() {
    return <StreamPlaceholder />;
  }
}

class ChatStream extends React.Component<Props> {
  // @ts-expect-error ts-migrate(2564) FIXME: Property 'stream' has no initializer and is not de... Remove this comment to see the full error message
  stream: Stream;

  handleNewBottomItem = () => {
    if (this.stream) {
      this.stream.scrollToBottom();
    }
  };

  render() {
    return (
      <StreamContext.Provider value={CTX_CHAT_STREAM}>
        {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: (props: any) => Element; uuid: s... Remove this comment to see the full error message */}
        <ChatStreamContainer uuid={this.props.uuid} onNewBottomItem={this.handleNewBottomItem}>
          {/* @ts-expect-error ts-migrate(7006) FIXME: Parameter 'props' implicitly has an 'any' type. */}
          {(props) => (
            <Stream
              {...props}
              uuid={this.props.uuid}
              ref={(e: any) => (this.stream = e)}
              onScrollToBottom={this.props.onScrollToBottom}
            />
          )}
        </ChatStreamContainer>
      </StreamContext.Provider>
    );
  }
}

export { ChatStream };
export default ChatStream;
